"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = require("../colors.config");
var _helpers = require("../../components/utils/helpers");
var checkIcon = (0, _helpers.getImageByAgent)('task-complete.svg');
var _default = exports.default = {
  root: {
    '& svg': {
      border: "1px solid ".concat(_colors.Black[150]),
      'border-radius': '3px',
      height: '17px',
      width: '17px'
    },
    '& svg path': {
      display: 'none'
    },
    '&.Mui-checked::after': {
      backgroundImage: "url(".concat(checkIcon, ")"),
      backgroundRepeat: 'no-repeat',
      content: '""',
      display: 'block',
      height: '17px',
      pointerEvents: 'none',
      position: 'absolute',
      width: '17px'
    }
  }
};